import React, {forwardRef} from 'react';
import PropTypes from 'prop-types';
import styles from './TextBox.scss';

const TextBox = forwardRef((props, ref) => {
	const {
		name,
		type = 'text',
		onChange,
		autoComplete,
		placeholder,
		value,
		maxLength,
		layout = 'Default',
		color = '',
		dataSet = {},
		hasError = false,
		error = '',
		required,
		tabindex,
		onBlur,
		onFocus,
		onKeyDown,
		readonly,
		disabled,
		id,
		defaultValue
	} = props;

	// Подготовка на data-* атрибутите
	//////////////////////////////////////////////////
	const innerDataSet = Object.keys(dataSet).reduce((acc, key) => {
		acc[`data-${key}`] = dataSet[key];
		return acc;
	}, {});

	//////////////////////////////////////////////////

	let labelClassInner = styles[layout] || styles.Default;
	let classNameInner = styles.input;
	let hasErrorInner = hasError || error !== '';

	//////////////////////////////////////////////////

	if (hasErrorInner) classNameInner += ` ${styles.hasError}`;
	if (disabled) labelClassInner += ` ${styles.disabled}`;
	if (color) labelClassInner += ` ${styles[color]}`;

	//////////////////////////////////////////////////

	const hasIcon = layout === 'SearchTransparent' || layout === 'SearchWhite' || layout === 'SearchWhiteCircle';

	return (
	  <div className={styles.container}>
		  <label className={labelClassInner}>
			  {hasIcon &&
				<span className={styles.icon} aria-hidden="true"/>
			  }
			  <input
				ref={ref}
				type={type}
				name={name}
				placeholder={placeholder}
				value={value}
				defaultValue={defaultValue}
				onChange={onChange}
				maxLength={maxLength}
				required={required}
				tabIndex={tabindex}
				onBlur={onBlur}
				onFocus={onFocus}
				onKeyDown={onKeyDown}
				readOnly={readonly}
				disabled={disabled}
				id={id}
				autoComplete={autoComplete}
				className={classNameInner}
				{...innerDataSet}
			  />
		  </label>

		  {error !== '' && (
			<div
			  className={styles.error}
			  dangerouslySetInnerHTML={{__html: error}}
			/>
		  )}
	  </div>
	);
});

TextBox.displayName = 'TextBox';

TextBox.propTypes = {
	name: PropTypes.string.isRequired,
	onChange: PropTypes.func,
	type: PropTypes.string,
	placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	value: PropTypes.string,
	maxLength: PropTypes.number,
	layout: PropTypes.oneOf(['Default', 'SearchTransparent', 'SearchWhite', 'SearchWhiteCircle']),
	color: PropTypes.string,
	dataSet: PropTypes.objectOf(PropTypes.string),
	error: PropTypes.string,
	hasError: PropTypes.bool,
	id: PropTypes.string,
	required: PropTypes.bool,
	readonly: PropTypes.bool,
	disabled: PropTypes.bool,
	tabindex: PropTypes.number,
	onBlur: PropTypes.func,
	onFocus: PropTypes.func,
	onKeyDown: PropTypes.func,
	autoComplete: PropTypes.string,
	defaultValue: PropTypes.string
};

export default TextBox;